import { GenericPage } from "../../../../../pages";
import {
  resourcesReportsRoute
} from "./resources-reports.route";
import { clientRoute } from "./resources-client.route";
import { exportersRoute } from "./resources-exporters.route";
import { videosRoute } from "./resources-videos.route";
import { resourcesStatisticsRoute } from "./resources-statistics.route";


export const resourcesRoute = [
  {
    path: 'reports',
    element: <GenericPage />,
    children:resourcesReportsRoute, 
  },
  {
    path: 'clients',
    element: <GenericPage />,
    children: clientRoute,
  },
  {
    path: 'exporters',
    element: <GenericPage />,
    children: exportersRoute,
  },
  {
    path: 'statistics',
    element: <GenericPage />,
    children: resourcesStatisticsRoute,
  },
  {
    path: 'videos',
    element: <GenericPage />,
    children: videosRoute,
  },
]